export function extractErrorMessage(error, fallbackMessage = 'Request failed') {
    const responseData = error?.response?.data

    if (typeof responseData?.message === 'string' && responseData.message.trim()) {
        return responseData.message.trim()
    }

    if (typeof responseData?.error === 'string' && responseData.error.trim()) {
        return responseData.error.trim()
    }

    if (typeof error?.message === 'string' && error.message.trim()) {
        return error.message.trim()
    }

    return fallbackMessage
}
